import { useAuth } from '@/contexts/AuthContext'
import { accountApiService, accountQueries } from '@/services/accountApi'
import type { Contact, ContactLabel } from '@/types/account'
import { useInfiniteScrollQuery } from './useInfiniteScrollQuery'

export const CONTACTS_PAGE_SIZE = 25

interface UseInfiniteContactsQueryOptions {
  label?: ContactLabel
  query?: string
}

export const useInfiniteContactsQuery = ({
  label,
  query,
}: UseInfiniteContactsQueryOptions = {}) => {
  const { isAuthenticated } = useAuth()

  const { items: contacts, ...rest } = useInfiniteScrollQuery<
    Awaited<ReturnType<typeof accountApiService.getContacts>>,
    Contact
  >({
    queryKey: [...accountQueries.contactsInfiniteBase, label ?? null, query ?? null],
    queryFn: (page, pageSize) => accountApiService.getContacts(page, pageSize, label, query),
    transform: (data) => ({
      items: data.contacts,
      totalItems: data.totalItems,
      totalPages: data.totalPages,
      page: data.page,
    }),
    pageSize: CONTACTS_PAGE_SIZE,
    enabled: isAuthenticated,
  })

  return { contacts, ...rest }
}
